var FRONTMATTER_MD_REGEX = /^---(.|\n)*?---\n/;

function fn(str) {
  return str.replace(/^\s+|\s+$/g, "").replace(FRONTMATTER_MD_REGEX, "");
}

export var removeFrontmatter = function removeFrontmatter(_a) {
  var source = _a.source;
  return fn(source.content || source.rawContent);
};